import apiClient from './client';

export const lockKeystone = async (slug) => {
  const res = await apiClient.post('/api/keystones/lock', { keystone_slug: slug });
  return res.data;
};
